function SkeletonRect({ width, height, clipId, fillId }: { width: number; height: number; clipId: string; fillId: string }) {
  return (
    <svg role="img" width="100%" height={height} aria-labelledby="loading-aria" viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none" style={{ display: 'block' }}>
      <title id="loading-aria">Loading...</title>
      <rect x="0" y="0" width="100%" height="100%" clipPath={`url(#${clipId})`} style={{ fill: `url(#${fillId})` }} />
      <defs>
        <clipPath id={clipId}>
          <rect x="0" y="0" rx="0" ry="0" width={width} height={height} />
        </clipPath>
        <linearGradient id={fillId}>
          <stop offset="0.599964" stopColor="#f3f3f3" stopOpacity="1">
            <animate attributeName="offset" values="-2; -2; 1" keyTimes="0; 0.25; 1" dur="2s" repeatCount="indefinite" />
          </stop>
          <stop offset="1.59996" stopColor="#ecebeb" stopOpacity="1">
            <animate attributeName="offset" values="-1; -1; 2" keyTimes="0; 0.25; 1" dur="2s" repeatCount="indefinite" />
          </stop>
          <stop offset="2.59996" stopColor="#f3f3f3" stopOpacity="1">
            <animate attributeName="offset" values="0; 0; 3" keyTimes="0; 0.25; 1" dur="2s" repeatCount="indefinite" />
          </stop>
        </linearGradient>
      </defs>
    </svg>
  )
}

interface PropertySkeletonProps {
  index: number
  imageWidth?: number
  imageHeight?: number
}

export default function PropertySkeleton({ index, imageWidth = 400, imageHeight = 250 }: PropertySkeletonProps) {
  const suffix = `-${index}`

  return (
    <div className="property-item hfse-property-container property-loading" data-ind={index}>
      <div className="hk-card hk-card-default hk-card-hover hk-card-small hk-link-toggle hk-flex hk-flex-column hfse-property-card">
        <div className="hk-card-media-top hfse-property-media">
          <SkeletonRect width={imageWidth} height={imageHeight} clipId={`clip-path-thumbnail${suffix}`} fillId={`fill-thumbnail${suffix}`} />
        </div>
        <div className="hk-card-body hk-margin-remove-first-child hfse-property-body">
          <h3 className="hk-h5 hfse-property-title">
            <SkeletonRect width={300} height={24} clipId={`clip-path-title${suffix}`} fillId={`fill-title${suffix}`} />
          </h3>
          <div className="hk-margin-small-top hfse-property-price-container">
            <span className="hfse-property-price">
              <SkeletonRect width={200} height={20} clipId={`clip-path-price${suffix}`} fillId={`fill-price${suffix}`} />
            </span>
          </div>
        </div>

        <div className="hfse-property-meta">
          <div className="hfse-property-meta-primary">
            <div className="terms terms-left">
              <SkeletonRect width={60} height={20} clipId={`clip-path-term-l${suffix}`} fillId={`fill-term-l${suffix}`} />
            </div>
            <div className="terms terms-right">
              <SkeletonRect width={60} height={20} clipId={`clip-path-term-r${suffix}`} fillId={`fill-term-r${suffix}`} />
            </div>
          </div>
          <div className="hfse-property-meta-secondary">
            <div>
              <SkeletonRect width={40} height={20} clipId={`clip-path-unit-g${suffix}`} fillId={`fill-unit-g${suffix}`} />
            </div>
            <div>
              <SkeletonRect width={40} height={20} clipId={`clip-path-unit-b${suffix}`} fillId={`fill-unit-b${suffix}`} />
            </div>
            <div>
              <SkeletonRect width={40} height={20} clipId={`clip-path-unit-t${suffix}`} fillId={`fill-unit-t${suffix}`} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
